module.exports = __webpack_public_path__ + "img/bolt.42de93f8.svg";